<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
                [routerLink]="['/request/incometax/taxdeclaration/add/0']" [disabled]="isDisabled">
                <i class="bi bi-ui-checks" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Tax Declaration':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Tax Declaration
        </div>
        <div class="card-body p-1">
            <div class="mb-2">
                <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                    <div class="row mx-1">
                        <div class="col-md-3">
                            <label>Financial Year</label>
                            <ng-select name="ESS_TaxFinancialYearID" [items]="FinancialYears" bindLabel="FinancialYear"
                                bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Filter.ESS_TaxFinancialYearID"
                                placeholder="Financial Year">
                            </ng-select>
                        </div>
                        <div class="col-md-2">
                            <label for="ApprovalStatus" class="form-font-label">Status</label>
                            <ng-select id="ApprovalStatus" name="ApprovalStatus" [items]="common.Status"
                                bindLabel="Name" bindValue="Value" placeholder="Status"
                                [(ngModel)]="this.Filter.ApprovalStatus">
                            </ng-select>
                            <div class="invalid-feedback">
                                Please select status!
                            </div>
                        </div>
                        <!-- <div class="col-md-3">
                            <label for="FromDateObj" class="form-font-label">From Date</label>
                            <div class="input-group">
                                <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                                    [(ngModel)]="Filter.FinancialYearFromObj" ngbDatepicker #FromDateObj="ngbDatepicker"
                                    readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                                    type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please select from date!
                            </div>
                        </div>
                        <div class="col-md-3">
                            <label for="ToDateObj" class="form-font-label">To Date</label>
                            <div class="input-group">
                                <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                                    [(ngModel)]="Filter.FinancialYearFromObj" ngbDatepicker #ToDateObj="ngbDatepicker"
                                    readonly />
                                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                                    type="button"></button>
                            </div>
                            <div class="invalid-feedback">
                                Please select to date!
                            </div>
                        </div> -->
                        <!-- <div class="col-md-2 align-content-center">
                            <span>Draft : <input type="checkbox" name="IsDraft" [(ngModel)]="Filter.IsDraft" ngbCheckbox
                                    (change)="clear()" /></span>
                        </div> -->
                        <div class="col"></div>
                        <div class="col-md-auto align-content-center">
                            <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Apply':'Loading...'}}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div>
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 5px;">#</th>
                            <!-- <th style="width: 5px;">Action</th>
                            <th style="width: 10px;" [ngClass]="{'colHide': this.Filter.IsDraft}">Tracking</th> -->
                            <th style="width: 5px;">View</th>
                            <th style="width: 5px;">Tacking</th>
                            <th>Financial Year Start</th>
                            <th>Financial Year End</th>
                            <th style="width: 20px;">Regime</th>
                            <!-- <th style="width: 20px;">{{this.Filter.IsDraft?'SubmissionStatus':'ApprovalStatus'}}</th> -->
                            <th style="width: 20px;">ApprovalStatus</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TableDatas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <!-- <td style="width: 5px;">
                                <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                        [routerLink]="['/request/incometax/taxdeclaration/detail/' + TableData['ESS_EmpTaxDeclarationID']] + '/'+Filter.IsDraft"><i
                                            class="bi bi-info-square me-1"></i>View</button></div>
                            </td>
                            <td style="width: 10px;" [ngClass]="{'colHide': this.Filter.IsDraft}">
                                <div style="width: 100px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                        (click)="Tracking(i)">
                                        <i class="bi bi-person-lines-fill me-1"></i>Tracking</button></div>
                            </td> -->
                            <td style="width: 5px;">
                                <div class="text-center">
                                    <i class="bi bi-trash text-danger me-2"
                                        (click)="ESS_EmpTaxDeclaration_InsertUpdate(TableData['ESS_EmpTaxDeclarationID'])"
                                        *ngIf="TableData['IsDraft']"></i>
                                    <i [routerLink]="['/request/incometax/taxdeclaration/detail/' + TableData['ESS_EmpTaxDeclarationID']]"
                                        class="bi bi-eye text-success"></i>
                                </div>
                            </td>
                            <td style="width: 5px;">
                                <div class="text-center" *ngIf="!TableData['IsDraft']"><i (click)="Tracking(i)"
                                        class="bi bi-person-lines-fill text-warning"></i></div>
                            </td>
                            <td>{{TableData['FinancialYearStart']}}</td>
                            <td>{{TableData['FinancialYearEnd']}}</td>
                            <td style="width: 20px;">{{TableData['IsNewRegime']?'New':'Old'}}</td>
                            <td style="width: 5px;">
                                <span class="badge" *ngIf="!TableData['IsDraft']"
                                    [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">
                                    {{TableData['ApprovalStatus']}}</span>
                                <span class="badge view" *ngIf="TableData['IsDraft']">
                                    Draft</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>